import { CSSProperties, useMemo } from 'react'
import { Position } from 'types'

const useDragCss = (position: Position): CSSProperties => {
    const css = useMemo(
        () => ({
            height: position.height,
            transform: `translate(${position.x}px, ${position.y}px)`,
            width: position.width,
        }),
        [position]
    )

    return css
}

export default useDragCss
